import React from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Hidden from "@material-ui/core/Hidden";
import Icon from "@mdi/react";
import {
  mdiDesktopClassic,
  mdiRocket,
  mdiLighthouse,
  mdiMailboxUpOutline,
  mdiGithubFace,
  mdiPrinter
} from "@mdi/js";
import { RouterLink } from "../../components/Link/Link";
import ExternalLink from "../../components/Link/ExternalLink";
import Pdf from "../../pdf/Karan More_Resume.pdf";

export const getLinks = (listItems, toggleDrawer) =>
  listItems.map(({ name, to, iconPath, component = RouterLink }) => {
    const path = to || `/${name.toLowerCase()}`;
    const selected = window.location.pathname === path;

    return (
      <ListItem
        button
        component={component}
        to={path}
        href={path}
        key={name}
        onClick={toggleDrawer}
        selected={selected}
      >
        <ListItemIcon>
          <Icon path={iconPath} size={1} color="currentColor" />
        </ListItemIcon>
        <ListItemText primary={name} />
      </ListItem>
    );
  });

export default function Links({ toggleDrawer }) {
  return (
    <>
      <Divider />
      <List>
        {getLinks(
          [{ name: "Home", to: "/", iconPath: mdiRocket }],
          toggleDrawer
        )}

        <Hidden smUp>
          {getLinks(
            [
              {
                name: "Contributions",
                to: "https://github.com/karan-more",
                component: ExternalLink,
                iconPath: mdiGithubFace
              },
              {
                name: "Print resume",
                to: Pdf,
                component: ExternalLink,
                iconPath: mdiPrinter
              }
            ],
            toggleDrawer
          )}
          {getLinks(
            [{ name: "Contact", iconPath: mdiMailboxUpOutline }],
            toggleDrawer
          )}
        </Hidden>
      </List>
    </>
  );
}

Links.propTypes = {
  toggleDrawer: PropTypes.func
};

Links.defaultProps = {
  toggleDrawer: () => {}
};
